import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig} from "config/config"; // Importing development configuration

export default class tableDepositReportView extends JetView { // Defining a new class extending JetView
    config() { // Method to define the UI configuration
        const _ = this.app.getService("locale")._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var direction = false; // Variable to hold sorting direction
        var vthis = this; // Reference to the current instance

        // Custom data filter for summing values in a tree column
        webix.ui.datafilter.summTreeColumn = webix.extend({
            refresh: function (master, node, value) { // Refresh method for the filter
                var result = 0; // Variable to hold the sum result
                var resultFormat = 0; // Variable for formatted result
                master.data.each(function (obj) { // Iterate through each data object
                    if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                });
                // Format the result based on the column ID
                if (value.columnId === 'CantidadTickets') {
                    resultFormat = webix.i18n.intFormat(result); // Integer format for ticket count
                } else {
                    resultFormat = webix.i18n.priceFormat(result); // Price format for other values
                }
                node.firstChild.innerHTML = resultFormat; // Update the node's inner HTML with the formatted result
            }
        }, webix.ui.datafilter.summColumn); // Extend the summColumn filter

        // Custom data filter for summing values in a regular column
        webix.ui.datafilter.mySummColumn = webix.extend({
            refresh: function (master, node, value) { // Refresh method for the filter
                var result = 0; // Variable to hold the sum result
                var resultFormat = 0; // Variable for formatted result
                var size = $$('datatable4').getPager().config.size; // Get page size
                var page = $$('datatable4').getPage(); // Get current page
                var first = size * page; // Calculate the first index of the current page
                var last = (first + size) - 1; // Calculate the last index of the current page
                var count = 0; // Counter for iterating through data
                master.data.each(function (obj) { // Iterate through each data object
                    if (count >= first && count <= last) { // Check if within current page range
                        result += parseFloat(obj[value.columnId]) // Sum the value for the current column
                    }
                    count++; // Increment the counter
                });
                resultFormat = webix.i18n.priceFormat(result); // Format the result as price
                node.firstChild.innerHTML = resultFormat; // Update the node's inner HTML with the formatted result
            }
        }, webix.ui.datafilter.summColumn); // Extend the summColumn filter

        return { // Return the configuration object for the view
            rows: [
                {
                    type: "wide", // Type of the UI component
                    view: "datatable", // DataTable view
                    id: "datatable4", // Unique identifier for the DataTable
                    css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                    columns: [ // Define columns for the DataTable
                        {
                            id: "Id", // Column ID
                            header: "ID", // Column header
                            width: 100 // Column width
                        },
                        {
                            id: "UserId", // Column ID
                            header: _("ID Usuario"), // Column header with localization
                            width: 100 // Column width
                        },
                        {
                            id: "Email", // Column ID
                            header: _("Email"), // Column header with localization
                            width: 300 // Column width
                        },
                        {
                            id: "Type", // Column ID
                            header: _("Tipo"), // Column header with localization
                            width: 200 // Column width
                        },
                        {
                            id: "DateTime", // Column ID
                            header: _("Fecha y hora"), // Column header with localization
                            fillspace: 0, // Disable fillspace
                            minWidth: 0, // Minimum width
                            width: 250, // Column width
                            format: dateFormat // Date formatting
                        },
                        {
                            id: "EndDate", // Column ID
                            header: _("Fecha en que finaliza"), // Column header with localization
                            fillspace: 0, // Disable fillspace
                            minWidth: 0, // Minimum width
                            width: 250, // Column width
                            format: dateFormat // Date formatting
                        },
                        {
                            id: "Amount", // Column ID
                            header: _("Valor"), // Column header with localization
                            width: 100 // Column width
                        },{
                            id: "TimeLimit", // Column ID
                            header: _("Horas"), // Column header with localization
                            width: 150 // Column width
                        },
                        {
                            id: "State", // Column ID
                            header: _("Estado"), // Column header with localization
                            width: 150 // Column width
                        },
                        {
                            id: "ModifyDate", // Column ID
                            header: _("Fecha modificación"), // Column header with localization
                            fillspace: 0, // Disable fillspace
                            minWidth: 0, // Minimum width
                            width: 250, // Column width
                            format: dateFormat // Date formatting
                        },
                        {
                            id: "Observation", // Column ID
                            header: _("Observación"), // Column header with localization
                            width: 400 // Column width
                        },
                    ],
                    on: { // Event handlers for the DataTable
                        onBeforeLoad: function () { // Before loading data
                            this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>"); // Show loading overlay
                        },
                        onAfterLoad: function () { // After loading data
                            this.hideOverlay(); // Hide loading overlay
                        }
                    },
                    ready: function () { // When the DataTable is ready
                        if (!this.count()) { // Check if there are no records
                            webix.extend(this, webix.OverlayBox); // Extend with OverlayBox functionality
                            this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>"); // Show no data overlay
                        }
                    },
                    tooltip: true, // Enable tooltips
                    footer: true, // Enable footer
                    math: true, // Enable mathematical operations
                    loadahead: 0, // Load ahead configuration
                    datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                    pager: "pagerA" // Pager ID for pagination
                },
            ]
        };
    }
    
    init(grid) { // Method to initialize the view
        var gridppal = $$('datatable4'); // Reference to the main DataTable
        var url = devConfig.geturlApi() + "es/Report/GetReportUserLimits"; // API URL for fetching report data
        var flag = false; // Flag for export operation
        var filter = ""; // Filter string for data fetching

        // Event listener for deposit report filtering
        this.on(this.app, "depositReport:filter", filterData => {
            function buildQueryUrl(baseUrl, filters) { // Function to build the query URL with filters
                const params = []; // Array to hold query parameters
                Object.entries(filters).forEach(([key, value]) => { // Iterate through filters
                    if (key.includes("Date")) { // Check if the key is a date
                        if (key.includes("Date")) {
                            let prefix = key.replace("Date", ""); // Extract prefix from key
                            let date = value.split(" - "); // Split date range
                            params.push(`dateFrom${prefix}=${date[0]}&dateTo${prefix}=${date[1]}`); // Add date parameters
                        }
                    } else if (value !== '') { // Check if value is not empty
                        params.push(`${key}=${encodeURIComponent(value)}`); // Add other parameters
                    }
                });
                return `${baseUrl}&${params.join('&')}`; // Return the constructed URL
            }
            const queryUrl = buildQueryUrl(url + '?start=0&count=' + gridppal.data.$pagesize, filterData); // Build the query URL
            gridppal.clearAll(); // Clear existing data in the DataTable
            gridppal.load(queryUrl); // Load new data into the DataTable
        });

        // Event listener for export filtering
        this.on(this.app, "export:filter", filterData => {
            console.log(filterData); // Log filter data
            flag = true; // Set flag for export operation
            var firstfirst; // Variable to hold the first index for export
            if (filterData.first == 0) { // Check if first index is 0
                firstfirst = filterData.first + 1; // Adjust first index
            } else {
                firstfirst = filterData.first; // Keep first index as is
            }
            gridppal.load(url + '?start=' + (firstfirst) + '&count=' + (filterData.last + 1) + filter); // Load data for export
            $$("datatable4").attachEvent("onAfterLoad", function () { // After loading data for export
                if (flag) { // Check if export flag is set
                    var size = $$('datatable4').getPager().config.size; // Get page size
                    var page = $$('datatable4').getPage(); // Get current page
                    var first = size * page; // Calculate first index
                    var last = (first + size) - 1; // Calculate last index
                    if ($$("Export").getValue() == '1') { // Check if export type is Excel
                        for (var j = 0; j < gridppal.config.columns.length; j++) { // Iterate through columns
                            if (gridppal.config.columns[j].exportType) { // Check if column is exportable
                                delete gridppal.config.columns[j].format; // Remove format for export
                            }
                        }
                        this.app.callEvent("export:data", [{ // Trigger export data event
                            NameReport: ($$("datatable4").count() > 0 ? "" : _("No hay datos - ")) + "Limitaciones", // Report name
                            TypeReport: "Excel" // Report type
                        }]);
                        webix.toExcel(gridppal, { // Export to Excel
                            filter: function (obj) { // Filter function for export
                                return $$("datatable4").getIndexById(obj.id) >= first && $$("datatable4").getIndexById(obj.id) <= last; // Check index range
                            },
                            filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", {hour12: true}).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable4").count() > 0 ? "" : _("No hay datos - ")) + "Limitaciones", // Filename for the export
                            ignore: {"detailTittle": true}, // Ignore detail title in export
                            footer: false // Do not include footer in export
                        });
                    } else { // If export type is not Excel
                        if ($$("Export").getValue() == '2') { // Check if export type is PDF
                            this.app.callEvent("export:data", [{ // Trigger export data event
                                NameReport: ($$("datatable4").count() > 0 ? "" : _("No hay datos - ")) + "Limitaciones", // Report name
                                TypeReport: "PDF" // Report type
                            }]);
                            webix.toPDF($$("datatable4"), { // Export to PDF
                                filter: function (obj) { // Filter function for export
                                    return $$("datatable4").getIndexById(obj.id) >= first && $$("datatable4").getIndexById(obj.id) <= last; // Check index range
                                },
                                filename: "Virtualsoft - " + new Date().toLocaleString("en-GB", {hour12: true}).replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1').replace(/[\/:]/g, '_').toUpperCase() + " - " + ($$("datatable4").count() > 0 ? "" : _("No hay datos - ")) + "Limitaciones", // Filename for the export
                                autowidth: true, // Enable auto width for PDF
                                ignore: {"detailTittle": true}, // Ignore detail title in export
                                footer: false // Do not include footer in export
                            });
                        }
                    }
                    flag = false; // Reset export flag
                    $$("Export").setValue(""); // Reset export selection
                }
            }.bind(this)); // Bind the context to the current instance
        });

        // Event listener for sorting the DataTable
        gridppal.attachEvent("onAfterSort", function (by, dir, as) {
            console.log('as: ' + as) // Log sorting direction
            gridppal.load(url + '?start=0&count=' + gridppal.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for player selection
        this.on(this.app, "player:select", Id => {
            gridppal.load(gridppal.data.url + '?start=0&count=' + gridppal.data.$pagesize + '&PlayerId=' + Id); // Load data based on selected player
        });
    }
}

// FILE DOCUMENTED
